import React, { useRef, useState, useEffect } from "react";
import { jsPDF } from "jspdf";
import domtoimage from "dom-to-image-more";
import FarmerCropHealth from "./FarmerCropHealth";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
const FarmerCropDynamicData = ({ SendPlotData, allData, RoleAcessParams,activeCard ,id}) => {
  const mapRef = useRef(null);
  const [contentLoading, setContentLoading] = useState(true); // State for content loading

  // const handleDownloadPDF = async () => {
  //   if (!mapRef.current) return;

  //   try {
  //     const imgData = await domtoimage.toPng(mapRef.current, {
  //       useCORS: true,
  //       bgcolor: "#fff",
  //       filter: (node) => {
  //         if (node.tagName === "LINK" && node.href.includes("cloudflare.com")) {
  //           return false;
  //         }
  //         return true;
  //       },
  //     });

  //     const pdf = new jsPDF({
  //       orientation: "portrait",
  //       unit: "px",
  //       format: [mapRef.current.scrollWidth, mapRef.current.scrollHeight],
  //     });

  //     pdf.addImage(imgData, "PNG", 0, 0, mapRef.current.scrollWidth, mapRef.current.scrollHeight);
  //     pdf.save("map.pdf");
  //   } catch (error) {
  //     console.error("Error capturing map as PDF:", error);
  //   }
  // };
  useEffect(() => {
    const timer = setTimeout(() => {
      setContentLoading(false); // Show content after 1 second
    }, 2000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  return (
    <React.Fragment>
      {/* <button onClick={handleDownloadPDF}>Download PDF</button> */}
      {/* <div className="container mt-3" ref={mapRef}> */}
      <div className="container mt-3">
        {contentLoading ? (
          <div className="text-center mt-3">
            <Skeleton count={20} />
          </div>
        ) : (
          // <div className="shadow mt-4 mb-4 custom-shadow">
          <FarmerCropHealth
            plotData={SendPlotData}
            allData={allData}
            RoleAcessParams={RoleAcessParams}
            activeCard={activeCard}
            id={id}
          />
          // </div>
        )}{" "}
      </div>
    </React.Fragment>
  );
};

export default FarmerCropDynamicData;
